/**
 * Created by Andrey Popov on 07.08.26
 */

const InviteFriendsCongratWindow = Prefab.createWindow("invite_friends_window", "invitefriendscongratwindow_prefab_json");
